<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M14.2237 4.85216V0.0473557H4.01477C3.46587 0.0473557 3.02087 0.492351 3.02087 1.04125V23.0061C3.02087 23.555 3.46587 24 4.01477 24H19.9169C20.4658 24 20.9108 23.555 20.9108 23.0061V6.7097H16.0812C15.057 6.7097 14.2237 5.87641 14.2237 4.85216ZM10.21 18.8325L8.09556 20.947C7.95854 21.084 7.77894 21.1525 7.59939 21.1525C7.41984 21.1525 7.24019 21.0841 7.10321 20.947L6.22538 20.0693C5.95133 19.7952 5.95133 19.3509 6.22538 19.0769C6.49939 18.8028 6.94373 18.8028 7.21778 19.0769L7.59939 19.4585L9.21769 17.8402C9.49169 17.5661 9.93603 17.5661 10.2101 17.8402C10.4841 18.1142 10.4841 18.5585 10.21 18.8325ZM10.21 14.1543L8.09556 16.2687C7.95854 16.4058 7.77894 16.4743 7.59939 16.4743C7.41984 16.4743 7.24019 16.4058 7.10321 16.2688L6.22538 15.391C5.95133 15.1169 5.95133 14.6727 6.22538 14.3986C6.49939 14.1245 6.94373 14.1245 7.21778 14.3986L7.59939 14.7802L9.21769 13.1619C9.49169 12.8879 9.93603 12.8879 10.2101 13.1619C10.4841 13.4359 10.4841 13.8802 10.21 14.1543ZM10.21 9.11872L8.09556 11.2332C7.95854 11.3702 7.77894 11.4388 7.59939 11.4388C7.41984 11.4388 7.24019 11.3703 7.10321 11.2332L6.22538 10.3554C5.95133 10.0813 5.95133 9.63703 6.22538 9.36297C6.49939 9.08892 6.94373 9.08892 7.21778 9.36297L7.59939 9.74458L9.21769 8.12632C9.49169 7.85227 9.93603 7.85227 10.2101 8.12632C10.4841 8.40038 10.4841 8.84467 10.21 9.11872ZM17.2102 20.0953H12.719C12.3315 20.0953 12.0173 19.7811 12.0173 19.3936C12.0173 19.006 12.3315 18.6918 12.719 18.6918H17.2102C17.5977 18.6918 17.9119 19.006 17.9119 19.3936C17.9119 19.7811 17.5977 20.0953 17.2102 20.0953ZM12.0173 14.7153C12.0173 14.3278 12.3315 14.0136 12.719 14.0136H17.1901C17.5776 14.0136 17.8918 14.3278 17.8918 14.7153C17.8918 15.1029 17.5776 15.4171 17.1901 15.4171H12.719C12.3315 15.4171 12.0173 15.1029 12.0173 14.7153ZM17.8919 10.0371C17.8919 10.4246 17.5777 10.7388 17.1901 10.7388H12.7191C12.3315 10.7388 12.0173 10.4246 12.0173 10.0371C12.0173 9.64952 12.3315 9.33533 12.7191 9.33533H17.1901C17.5777 9.33533 17.8919 9.64952 17.8919 10.0371Z"
        :fill="
          name === 'creating'
            ? '#F2C94C'
            : name === 'intro'
            ? '#F2C94C'
            : name === 'bidding'
            ? '#F2994A'
            : name === 'canceled'
            ? '#EB5757'
            : name === 'pending'
            ? '#333333'
            : name === 'in_progress'
            ? '#2D9CDB'
            : name === 'done'
            ? '#27AE60'
            : color
        "
      />
      <path
        d="M15.6272 4.85215C15.6272 5.10253 15.8309 5.30622 16.0813 5.30622H20.9791L15.6272 3.8147e-06V4.85215Z"
        :fill="
          name === 'creating'
            ? '#F2C94C'
            : name === 'intro'
            ? '#F2C94C'
            : name === 'bidding'
            ? '#F2994A'
            : name === 'canceled'
            ? '#EB5757'
            : name === 'pending'
            ? '#333333'
            : name === 'in_progress'
            ? '#2D9CDB'
            : name === 'done'
            ? '#27AE60'
            : color
        "
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconPlanning',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    name: String,
  },
}
</script>
